import { z } from 'zod';

export const sendToNPSConfirmationSchema = z.object({
  amountOfParticipants: z.coerce.number().int().min(1).max(1000),
});

export type FormSendToNPSConfirmationSchema = z.infer<typeof sendToNPSConfirmationSchema>;
